import {PaymentMethod} from "@/lib/types/billing.ts";

import css from "@/pages/billing/payment-method/PaymentMethodDisplay.module.css";

export const CreditCardDisplay = ({paymentMethod}: {paymentMethod: PaymentMethod}) => {
  return (
    <>
      <img alt="Credit Card Logo" src={paymentMethod.img} className={css.PaymentMethodLogo} />
      XXXX&ndash;{paymentMethod.suffix}&nbsp;&ndash;&nbsp;Expires: {paymentMethod.expiration_date}
    </>
  );
};
